/**
 * Created by saeed on 1/31/2017.
 */
import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'jalali-moment';
import * as momenttz from 'moment-timezone';


@Pipe({name: 'toPersianDate'})
export class ToPersianDatePipe implements PipeTransform {
    transform(dateValue: string | Date) {
        // moment.loadPersian({usePersianDigits: true, dialect: 'persian'})
        moment.locale('fa')
        if (dateValue) {
            dateValue = new Date(dateValue.toString());
            // let tehranTime    = momenttz.tz(dateValue, "Asia/Tehran");
            let momentDate = moment(dateValue);

            if (momentDate) {

                return this.toPersianDigits(momentDate.format('jD jMMMM jYYYY'));
            } else {
                return dateValue;
            }
        } else {
            return '';
        }

    }

    toPersianDigits(number: string) {
        if (number) {
            var id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
            return number.replace(/[0-9]/g, function (w) {
                return id[+w]
            });
        }
    }
}

@Pipe({name: 'toPersianLongDate'})
export class ToPersianLongDatePipe implements PipeTransform {
    transform(dateValue: string | Date) {
        // moment.loadPersian({usePersianDigits: true, dialect: 'persian'})
        moment.locale('fa')
        if (dateValue) {
            dateValue = new Date(dateValue.toString())
            let momentDate = moment(dateValue);

            if (momentDate) {

                return this.toPersianDigits(momentDate.format('dddd jD jMMMM jYYYY'));
            } else {
                return dateValue;
            }
        } else {
            return '';
        }

    }

    toPersianDigits(number: string) {
        if (number) {
            var id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
            return number.replace(/[0-9]/g, function (w) {
                return id[+w]
            });
        }
    }
}

@Pipe({name: 'fromNow'})
export class FromNowPipe implements PipeTransform {
    transform(dateValue: string | Date) {
        // moment.loadPersian({usePersianDigits: true, dialect: 'persian'})
        moment.locale('fa')
        if (dateValue) {
            dateValue = new Date(dateValue.toString())
            let momentDate = moment(dateValue);

            if (momentDate) {

                return this.toPersianDigits(momentDate.from(moment.now()));
            } else {
                return dateValue;
            }
        } else {
            return '';
        }

    }

    toPersianDigits(number: string) {
        if (number) {
            var id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
            return number.replace(/[0-9]/g, function (w) {
                return id[+w]
            });
        }
    }
}

@Pipe({name: 'toPersianTime'})
export class ToPersianTimePipe implements PipeTransform {
    transform(dateValue: string | Date) {

        let jdate: Date;
        if (typeof dateValue == 'string') {
            let dstr = <string>dateValue;
            jdate = new Date(dstr);

        } else {

            jdate = <Date>dateValue;
        }


        if (jdate) {
            // let tehranTime = momenttz.tz(jdate, "Asia/Tehran");
            // tehranTime = this.correctDST(tehranTime); // FUCK REGIME!!!!!!
            // return this.toPersianDigits(this.ToZeroBaseNumber(tehranTime.hours()) + ':' + this.ToZeroBaseNumber(tehranTime.minutes()));
            return new Date(jdate).toLocaleTimeString("fa" , {hour12: false,hour: "2-digit", minute: "2-digit" , timeZone: 'Asia/Tehran'});
        } else {
            return dateValue;
        }

    }

    private correctDST(time: any) {

        return time;
    }

    ToZeroBaseNumber(num: number) {
        if (num < 10) {
            return '0' + num;
        } else {
            return num + '';
        }
    }

    toPersianDigits(number: string) {

        var id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        return number.replace(/[0-9]/g, function (w) {
            return id[+w]
        });
    }


}

@Pipe({name: 'toPersianMonth'})
export class ToPersianMonthPipe implements PipeTransform {
    transform(dateValue: string | Date) {

        moment.locale('fa')
        if (dateValue) {
            dateValue = new Date(dateValue.toString());
            // let tehranTime    = momenttz.tz(dateValue, "Asia/Tehran");
            let momentDate = moment(dateValue);

            if (momentDate) {

                return this.toPersianDigits(momentDate.format('jMMMM jYYYY'));
            } else {
                return dateValue;
            }
        } else {
            return '';
        }

    }

    toPersianDigits(number: string) {
        if (number) {
            var id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
            return number.replace(/[0-9]/g, function (w) {
                return id[+w]
            });
        }
    }
}






// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/pipes/persian-date.pipe.ts